<template>
    <div class="lni-c-box--content lni-u-mhauto lni-u-mv3">
        <lni-spinner
            v-if="isLoading"
            id="page-spinner"
            :inline="false"
        />
        <template v-else>
            <div
                v-if="hasError"
                class="lni-u-mb2"
            >
                <h1 class="lni-u-heading--2 lni-u-mv2">
                    There was an error setting up this page
                </h1>
                <p>
                    Please try reloading the page. If the problem persists, please contact Web Customer Support at 360-902-5999 weekdays between 8 a.m. and 5 p.m. (Pacific Time) or at WebSupport@lni.wa.gov.
                </p>
            </div>
            <template v-else>
                <h1 class="lni-u-heading--1">
                    {{ text.title }}
                </h1>
                <lni-child-labor-complaint-form
                    id="form"
                    classString="lni-u-mt3"
                />
            </template>
        </template>
    </div>
</template>

<script>
export default {
    name: 'LniHomePage',
    data() {
        return { isLoading: true };
    },
    computed: {
        text() {
            return this.$store.state.appState?.text;
        },
    },
    async mounted() {
        const result = await this.$store.dispatch('call', { oneLni: this.$oneLni });

        this.hasError = result === null;
        this.isLoading = false;

        if (!this.hasError) {
            this.$store.commit('appState/SET_VALUE', {
                key  : 'text',
                value: result,
            });
        }
    },
}; </script>